/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_validation_passwords_dont_match = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwords don't match`)
};

const zh_hans1_settings_validation_passwords_dont_match = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两次输入的密码不一致`)
};

const zh_hant1_settings_validation_passwords_dont_match = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密碼不一致`)
};

const fr_settings_validation_passwords_dont_match = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les mots de passe ne correspondent pas`)
};

const de_settings_validation_passwords_dont_match = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwörter stimmen nicht überein`)
};

const ja_settings_validation_passwords_dont_match = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードが一致しません`)
};

const ko_settings_validation_passwords_dont_match = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호가 일치하지 않습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_validation_passwords_dont_match = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_validation_passwords_dont_match(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_validation_passwords_dont_match", locale)
	if (locale === "en") return en_settings_validation_passwords_dont_match(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_validation_passwords_dont_match(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_validation_passwords_dont_match(inputs)
	if (locale === "fr") return fr_settings_validation_passwords_dont_match(inputs)
	if (locale === "de") return de_settings_validation_passwords_dont_match(inputs)
	if (locale === "ja") return ja_settings_validation_passwords_dont_match(inputs)
	return ko_settings_validation_passwords_dont_match(inputs)
};